export default __webpack_public_path__ + "static/media/evenShotMascot.4c79cd83.png";